import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"

class ResultModal extends Component {
    render() {
        const {modalResult, listError, listSuccess, onClose, onOpen} = this.props

        return (
            <th className='ResultModal'>
                <Modal isOpen={modalResult} toggle={onOpen}>
                    <ModalHeader toggle={onClose}>Kết quả</ModalHeader>
                    <ModalBody>
                        Đánh dấu thành công: <strong>{listSuccess.length}</strong> <br/>
                        Đánh dấu thất bại: <strong>{listError.length}</strong>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={onClose}>
                            Đóng
                        </Button>
                    </ModalFooter>
                </Modal>
            </th>
        )
    }
}

ResultModal.propTypes = {
    modalResult: PropTypes.bool,
    listError: PropTypes.array,
    listSuccess: PropTypes.array,
    onClose: PropTypes.func,
    onOpen: PropTypes.func
}

export default ResultModal